const exposedServiceTypes = ['bag', 'catering', 'lounge', 'equipment', 'miscellaneous']

export default exposedServiceTypes;
